import { preview } from '@/components/form/preview'
import { useTexts } from './hooks/useTexts'
//import { Restrictions } from './Restrictions'

type Props = {
  voice: uui.domain.server.rm.VoiceConfig
}

export function BackOfficeAdvancedProperties(props: Props) {
  const { voice } = props
  const texts = useTexts()

  if (voice.status !== 'ADVANCED' || voice.callbackConfig.status !== 'BACK_OFFICE') return null

  return (
    <>
      {/*
      //TODO: Re-enable that field once it will be available
      <ViewField label={texts.labels.restrictions}>
        <Restrictions voice={voice} />
      </ViewField>
      */}
      <preview.Field testId="voice-customer-callback-preference" label={texts.labels.preference}>
        {texts.value.preference.on}
      </preview.Field>
      <preview.Field testId="voice-phone-number" label={texts.labels.phone}>
        {voice.callbackConfig.backOfficePhone}
      </preview.Field>
    </>
  )
}
